export type ContentPermissionStatus = 'allowed' | 'denied' | 'loading' | 'unavailable';

export type ContentPermissionCapabilitySurface = 'view' | 'archived' | 'embed';

export type ContentPermissionUnavailableReason =
	| 'content_operations_error'
	| 'content_operations_missing'
	| 'content_type_missing'
	| 'super_admin_lookup_error';

export type ContentPermissionResult =
	| {
			status: Exclude<ContentPermissionStatus, 'unavailable'>;
			unavailableReason?: never;
	  }
	| {
			status: 'unavailable';
			unavailableReason: ContentPermissionUnavailableReason;
	  };

type ResolveRealtimePermissionStatusArgs = {
	contentPermissionResult: ContentPermissionResult | undefined;
	hasSuperAdminError: boolean;
	isSuperAdmin: boolean;
	isSuperAdminLoading: boolean;
};

/**
 * Super-admins can handle access requests without `restrict_content`.
 */
export const resolveRealtimePermissionStatus = ({
	contentPermissionResult,
	hasSuperAdminError,
	isSuperAdmin,
	isSuperAdminLoading,
}: ResolveRealtimePermissionStatusArgs): ContentPermissionResult | undefined => {
	if (contentPermissionResult?.status !== 'denied') {
		return contentPermissionResult;
	}

	if (hasSuperAdminError) {
		return {
			status: 'unavailable',
			unavailableReason: 'super_admin_lookup_error',
		};
	}

	if (isSuperAdminLoading) {
		return { status: 'loading' };
	}

	return { status: isSuperAdmin ? 'allowed' : 'denied' };
};
